<!-- Start Containerbar -->
<div id="containerbar" class="containerbar authenticate-bg">
  <p-toast></p-toast>
  <!-- Start Container -->
  <div class="container">
    <div class="auth-box forgot-password-box">
      <!-- Start row -->
      <div class="row no-gutters align-items-center justify-content-center">
        <!-- Start col -->
        <div class="col-md-6 col-lg-5">
          <!-- Start Auth Box -->
          <div class="auth-box-right">
            <div class="card">
              <div class="card-body">
                <form
                  class="email-form"
                  [formGroup]="emailForm"
                  (ngSubmit)="onSend()"
                >
                  <div class="form-head">
                    <a class="logo"
                      ><img
                        src="assets/images/logo.svg"
                        (click)="onReload()"
                        class="img-fluid"
                        alt="logo"
                    /></a>
                  </div>
                  <h4 class="text-primary my-4">Forgot Password?</h4>
                  <p class="mb-4" style="font-size: initial">
                    Enter the email address below to receive reset password
                    instructions.
                  </p>
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      autofocus="autofocus"
                      placeholder="Enter Registered Email"
                      required
                      formControlName="email"
                      [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                    />
                    <div
                      *ngIf="submitted && f.email.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.email.errors.required">
                        Please enter email address
                      </div>
                      <div *ngIf="f.email.errors.pattern">
                        Please enter a valid email address
                      </div>
                    </div>
                  </div>
                  <br />
                  <button
                    type="submit"
                    class="btn btn-primary-rgba btn-lg btn-block font-18"
                    [disabled]="disableBtn"
                  >
                    {{ button }}
                  </button>
                </form>
                <p class="mb-2 mt-3" style="font-size: initial">
                  Remember password ?
                  <a class="btn btnple font-18" [routerLink]="['/login']"
                    >Login</a
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- End Auth Box -->
        </div>
        <!-- End col -->
      </div>
      <!-- End row -->
    </div>
  </div>
  <!-- End Container -->
</div>
<!-- End Containerbar -->
